import React, { Component } from "react";
import Switch from "react-switch";
import Navbar from "../../components/Navbar.js";
import {
  alert,
  GET,
  PUT,
  loading,
  toFixed,
  BtnIcon,
} from "../../components/CustomComponent.js";
import Dropdown from "react-bootstrap/Dropdown";
import {DragDropContext,Draggable,Droppable} from "react-beautiful-dnd";
import "../../assets/css/bootstrap.css";
import "../../assets/css/style.css"; 
const title_data = {
  prev_balance_bank: "สรุปยอดบัญชีเงินฝากธนาคารและเงินสดคงเหลือในมือยกมา",
  prev_balance_cash: "รายการเงินสดคงเหลือในมือและอื่นๆ",

  income_received: "รายการรับเงิน",
  other_income: "รายรับอื่นๆ",
  deduction_amount: "หัก",
  expense_amount: "รายการจ่ายเงิน",
  bank_deposit_balance:
    "ยอดเงินฝากธนาคาร อาคารชุดบ้านเอื้ออาทรบางนา 5",
  cash_deposit_balance: "รายการเงินสดคงเหลือในมือและอื่นๆ",
};
export default class CashFlowReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdown: "",
      // TAB1
      prev_balance_bank: { show: false, data: [] },
      prev_balance_cash: { show: false, data: [] },
      // TAB2
      income_received: { show: false, data: [] },
      other_income: { show: false, data: [] },
      deduction_amount: { show: false, data: [] },
      expense_amount: { show: false, data: [] },
      bank_deposit_balance: { show: false, data: [] },
      cash_deposit_balance: { show: false, data: [] },

      tab: "ยอดที่ยกมา",
      setting_id: "",
    };
  }

  async componentDidMount() {
    loading(true);
    await this.Get();
    loading(false);
  }
  Get = async () => {
    let result = await GET("api/admin/setting-cash-flow-report/setting-list");
    if (result?.status) {
      this.setState({ ...result.data });
    }
  };
  Update = async () => {
    const {
      prev_balance_bank,
      prev_balance_cash,
      income_received,
      other_income,
      deduction_amount,
      expense_amount,
      bank_deposit_balance,
      cash_deposit_balance,
    } = this.state;
    loading(true);
    let id = this.state.setting_id;
    let body = {
      prev_balance_bank,
      prev_balance_cash,
      income_received,
      other_income,
      deduction_amount,
      expense_amount,
      bank_deposit_balance,
      cash_deposit_balance,
    };
    let result = await PUT(
      "api/admin/setting-cash-flow-report/setting-update/" + id,
      body
    );
    if (result?.status) {
      alert("#", "success");
    }
    loading(false);
  };
  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };
  componentTable = (data, data_index) => {
    return (
      <div className="card rounded-4 border-0 overflow-hidden mb-2" key={data_index}>
        <div className="table-responsive">
          <table className="table table-hover mb-0">
            <thead>
              <tr
                className="bg-success text-white pointer"
                onClick={() => {
                  this.setState((prevState) => ({
                    [data]: {
                      ...prevState[data],
                      show: !prevState[data].show,
                    },
                  }));
                }}
              >
                 <th></th>
                <th colSpan={3}>
                  <h6 className="fw-bold mb-1">{title_data[data]}</h6>
                </th>
                <th className="wpx-50 text-center">
                  <div className="icon text-16 ms-auto wpx-30 text-white">
                    {this.state[data]?.show ? "\uf077" : "\uf078"}
                  </div>
                </th>
              </tr>
            </thead>
            <DragDropContext
  onDragEnd={(result) => {
    if (!result.destination) return;

    const updatedData = this.reorder(
      this.state[data].data,
      result.source.index,
      result.destination.index
    );

    this.setState({
      [data]: { ...this.state[data], data: updatedData },
    });
  }}
>
  <Droppable droppableId="droppable">
    {(provided) => (
      <tbody ref={provided.innerRef} {...provided.droppableProps}>
        {this.state[data]?.data?.map((item, index) => (
          <Draggable
            key={"row_" + index}
            draggableId={"row_" + index}
            index={index}
          >
            {(providedRow) => (
              <tr
                ref={providedRow.innerRef}
                {...providedRow.draggableProps}
                {...providedRow.dragHandleProps}
                className="pointer"
              >
                <td {...providedRow.dragHandleProps} className={`wpx-40 text-center py-1 ${item.visible ? "" : "bg-secondary-light"}`}>
   <div className="icon text-secondary text-20">{"≡"}</div>
</td>
                    <td className={`wpx-40 text-center py-1 ${item.visible ? "" : "bg-secondary-light"}`}>
                      <Switch
                      className="mt-2"
                        height={20}
                        width={36}
                        onChange={() => {
                          const updatedData = [...this.state[data].data];
                          updatedData[index].visible =
                            !updatedData[index].visible;
                          this.setState({
                            [data]: { ...this.state[data], data: updatedData },
                          });
                        }}
                        checked={item.visible}
                      />
                    </td>
                    <td className={`py-1 ${item.visible ? "" : "bg-secondary-light"}`}>
                      <div className="d-flex align-items-center">
                        {item.title.map((title, title_index) => (
                          <div className="position-relative mx-1" key={title_index}>
                            <input
                              type={title.type}
                              className="form-control"
                              placeholder="ข้อความ..."
                              style={{
                                minWidth: 150,
                                width:
                                  title.value.length < 12
                                    ? 150
                                    : title.value.length * 7.1,
                                zIndex: 100,
                              }}
                              onChange={(e) => {
                                const updatedData = [...this.state[data].data];
                                updatedData[index].title[title_index].value =
                                  e.target.value;
                                this.setState({
                                  [data]: {
                                    ...this.state[data],
                                    data: updatedData,
                                  },
                                });
                              }}
                              value={title.value}
                              disabled={title.type === "date" || !item.visible}
                            />
                            {title_index !== 0 && item.visible && (
                              <div
                                className="icon text-white rounded-circle bg-danger wpx-20 hpx-20 d-flex align-items-center justify-content-center pointer position-absolute shadow"
                                style={{ top: -7, right: -7 }}
                                title="ลบช่องกรอก"
                                onClick={() => {
                                  const updatedData = [
                                    ...this.state[data].data,
                                  ];
                                  updatedData[index].title.splice(
                                    title_index,
                                    1
                                  );
                                  this.setState({
                                    [data]: {
                                      ...this.state[data],
                                      data: updatedData,
                                    },
                                  });
                                }}
                              >
                                {"\uf00d"}
                              </div>
                            )}
                            {title.type === "date" && item.visible && (
                              <div
                                className={`icon text-24 pt-1 text-white rounded-circle wpx-20 hpx-20 d-flex align-items-center justify-content-center pointer position-absolute shadow ${
                                  title.required ? "bg-warning" : "bg-secondary"
                                }`}
                                style={{ top: -7, right: 14 }}
                                title="จำเป็นต้องกรอก"
                                onClick={() => {
                                  const updatedData = [
                                    ...this.state[data].data,
                                  ];
                                  updatedData[index].title[
                                    title_index
                                  ].required =
                                    !updatedData[index].title[title_index]
                                      .required;
                                  this.setState({
                                    [data]: {
                                      ...this.state[data],
                                      data: updatedData,
                                    },
                                  });
                                }}
                              >
                                *
                              </div>
                            )}
                          </div>
                        ))}
                        {item.visible && (
                          <div className="position-relative">
                            <Dropdown>
                              <Dropdown.Toggle
                                variant="gray"
                                id="dropdown-basic"
                                size="sm"
                              >
                                <BtnIcon type="add" onClick={() => {}} />
                              </Dropdown.Toggle>
                              <Dropdown.Menu className="shadow overflow-hidden border-0 rounded-4 p-2">
                                <Dropdown.Item
                                  className="rounded-3 d-flex align-items-center px-2"
                                  onClick={() => {
                                    // แก้ไขการจัดการข้อมูลเพื่อให้ทำงานถูกต้อง
                                    let updatedData = [
                                      ...this.state[data].data,
                                    ];
                                    updatedData[index].title.push({
                                      value: "",
                                      type: "text",
                                      required: false,
                                    });
                                    this.setState({
                                      [data]: {
                                        ...this.state[data],
                                        data: updatedData,
                                      },
                                      dropdown: "",
                                    });
                                  }}
                                >
                                  ข้อความ
                                </Dropdown.Item>
                                <Dropdown.Item
                                  className="rounded-3 d-flex align-items-center px-2"
                                  onClick={() => {
                                    // แก้ไขการจัดการข้อมูลเพื่อให้ทำงานถูกต้อง
                                    let updatedData = [
                                      ...this.state[data].data,
                                    ];
                                    updatedData[index].title.push({
                                      value: "",
                                      type: "date",
                                      required: false,
                                    });
                                    this.setState({
                                      [data]: {
                                        ...this.state[data],
                                        data: updatedData,
                                      },
                                      dropdown: "",
                                    });
                                  }}
                                >
                                  วันที่
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        )}
                      </div>
                    </td>
                    <td
                      className={`text-end ${
                        item.visible ? "" : "bg-secondary-light"
                      }`}
                    >
                      {toFixed(item.amount)}
                    </td>
                    <td
                      className={`text-center ${
                        item.visible ? "" : "bg-secondary-light"
                      }`}
                    >
                      {/* Delete */}
                      <BtnIcon
                        type="delete"
                        onClick={async () => {
                          if (
                            await alert(
                              "",
                              "info",
                              "ยืนยัน",
                              "ยืนยันการลบข้อมูลนี้หรือไม่?",
                              "ลบข้อมูล",
                              "ยกเลิก"
                            )
                          ) {
                            const updatedData = [...this.state[data].data];
                            updatedData.splice(index, 1);
                            this.setState({
                              [data]: {
                                ...this.state[data],
                                data: updatedData,
                              },
                            });
                          }
                        }}
                      />
                    </td>
                  </tr>
            )}
          </Draggable>
        ))}
        
                <tr
                  className="bg-primary-light pointer"
                  onClick={() => {
                    const updatedData = [...this.state[data].data];
                    updatedData.push({
                      visible: true,
                      title_editable: data === "expense_amount" ? true : false,
                      title: [{ value: "", type: "text", required: false }],
                      amount_editable: true,
                      amount: 0.0,
                    });
                    this.setState({
                      [data]: { ...this.state[data], data: updatedData },
                    });
                  }}
                >
                  <td colSpan={5} className="bg-success-light">
                    <span className="icon text-primary me-2">{"\uf055"}</span>
                    เพิ่มรายการ
                  </td>
                </tr>
             {provided.placeholder}
      </tbody>
    )}
  </Droppable>
</DragDropContext>
          </table>
        </div>
      </div>
    );
  };
  render() {
    const { tab } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar
          header="Transaction History"
          page1="หน้าหลัก"
          page2="รายงานกระแสเงินสดรับ - กระแสเงินสดจ่าย"
        />
        <div className="body px-3 pb-3 pt-0 position-relative">
          <h4 className="fw-bold mb-3">
            รายงานกระแสเงินสดรับ - กระแสเงินสดจ่าย
          </h4>
          <div className="d-flex mb-3">
            <div
              className="border rounded-4 border-success mb-2 me-2"
              style={{ padding: 1 }}
            >
              <button
                className={`rounded-4 btn ${tab === "ยอดที่ยกมา" ? "btn-success": "btn-outline-success border-0"} wpx-150 mb-0`}
                onClick={() => this.setState({ tab: "ยอดที่ยกมา" })}
              >
                ยอดที่ยกมา
              </button>
              <button
                className={`rounded-4 btn ${tab === "กระแสเงินสด" ? "btn-success": "btn-outline-success border-0"} wpx-150 mb-0`}
                onClick={() => this.setState({ tab: "กระแสเงินสด" })}
              >
                กระแสเงินสด
              </button>
            </div>
          </div>
          <div className="pb-5 mb-5">
            {tab === "ยอดที่ยกมา" ? (
              <div>
                {/* DATA */}
                {["prev_balance_bank", "prev_balance_cash"].map(
                  (data, data_index) => this.componentTable(data, data_index)
                )}
              </div>
            ) : (
              <div>
                {/* DATA */}
                {[
                  "income_received",
                  "other_income",
                  "deduction_amount",
                  "expense_amount",
                  "bank_deposit_balance",
                  "cash_deposit_balance",
                ].map((data, data_index) =>
                  this.componentTable(data, data_index)
                )}
              </div>
            )}
            <h6 className="fw-bold">หมายเหตุ</h6>
            <div className="d-flex mb-2">
              <div
                className="icon text-24 pt-2 text-white rounded-circle wpx-20 hpx-20 d-flex align-items-center justify-content-center shadow bg-secondary me-3"
                style={{ top: -7, right: 14 }}
              >
                *
              </div>
              (Required) ไม่จำเป็นต้องกรอก
            </div>
            <div className="d-flex mb-2">
              <div
                className="icon text-24 pt-2 text-white rounded-circle wpx-20 hpx-20 d-flex align-items-center justify-content-center shadow bg-warning me-3"
                style={{ top: -7, right: 14 }}
              >
                *
              </div>
              (Required) จำเป็นต้องกรอก
            </div>
            <div className="d-flex mb-2">
              <div className="icon text-white rounded-circle bg-danger wpx-20 hpx-20 d-flex align-items-center justify-content-center shadow me-3">
                {"\uf00d"}
              </div>
              ลบช่องกรอกข้อมูล
            </div>
          </div>
          <div
            className="position-fixed w-100 bg-white p-3 d-flex justify-content-end shadow"
            style={{ bottom: 0, right: 0, zIndex: 10 }}
          >
            <button
              className="btn btn-danger px-5 me-1"
              onClick={() => {
                this.setState({ data: [] });
              }}
            >
              ล้างข้อมูล
            </button>
            <button
              className="btn btn-success px-5 ms-1"
              onClick={() => {
                this.Update();
              }}
            >
              บันทึก
            </button>
          </div>
        </div>
      </div>
    );
  }
}
